import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import * as backInter from 'app/auth/auth-data.model';
import { Subject } from 'rxjs';
import { ExpedienteService } from './expendiente.services';
import * as colabInter from './expediente.interface';
import { fuseAnimations } from '@fuse/animations';
///IDIOMAS
import { ColaboradoresEncuestadorService } from 'app/main/wizard-n35encuestador/services/colaboradoresEncuestador.service';
import {TranslateService} from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import Swal from 'sweetalert2';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_fileman } from 'app/idiomas/i18n/fileMan/filemanager.lang';
import { lang_wizard } from 'app/idiomas/i18n/expedientes35/wizard.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import *  as $ from 'jquery';
@Component({
  selector: 'app-expediente',
  templateUrl: './expediente.component.html',
  styleUrls: ['./expediente.component.scss'],
  animations : fuseAnimations
})
export class ExpedienteComponent implements OnInit {
panelOpenState = false;
//boolean cargando
//labelPosition: 'before' | 'after' = 'after';
cargando = true;
estadoCT=true;
info:any;
puedeCargar = false;
listadoGPTW = false;
carpetaActual = '';
numArchivos = new Array(10);
files: any[] = [];
guardandoArchivo = false;
colaboradoresStatus = false;
listaArchivosEmpresa: any;
tmp:boolean=true;
listaArchivosInstituto: backInter.getArchivosInstituto;
// Parte para centros de trabajo
//listaColaboradoresCT: backInter.getColaborador;
centrosTrabajo: backInter.getInfoCentros;
centrosTrabajoArray:any;
centrosTrabajoUsers:any;
productoCertificar: backInter.prodNorma35;
productoCertificar_CT: backInter.prodNorma35;
eventsSubject: Subject<any> = new Subject<any>();
eventsSubjectStatus: Subject<any> = new Subject<any>();
eventsSubjectStatusArchivos: Subject<any> = new Subject<any>();
eventsSubjectStatusMedicos: Subject<any> = new Subject<any>();
statusTable = true;
statusArchivos=true;
statusMedico:any;
tipos_ayuda:any;
idProducto_centroshijos:any;
mostrarTipos:boolean=false;
leveuser:any;
  private _unsubscribeAll: Subject<any>;
  constructor(
    private colaboradoresService: ColaboradoresEncuestadorService,
    private formBuilder: FormBuilder,
    private activated: ActivatedRoute,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private expedienteService: ExpedienteService,
    public dialog: MatDialog

  ) {
    this._unsubscribeAll = new Subject();
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_fileman.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.leveuser=localStorage.getItem('Leveuser');
    if(localStorage.getItem('Leveuser') == '6'){
      this.info=this.colaboradoresService.getinfo();
      localStorage.setItem('idProducto_padre',''+this.info.productoId)
      localStorage.setItem('Idct_BD',''+this.info.id_CT)
    }
    this.obtieneCertificarActual();
   }

  ngOnInit() {
    switch(this.expedienteService.getInfoUsuario().level){
      case 1: this.getListaArchivos(1,this.carpetaActual); break;
      case 2: this.getListaArchivos(2,this.carpetaActual); break;
    }
  }
  mostrar:boolean=false;
  obtieneCertificarActual(){
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            if(producto.completoNorma35 === 1){

              this.productoCertificar = producto;
              this.productoCertificar_CT = producto;
              this.cargando=false;
              this.estadoCT=false;
              if(this.productoCertificar.idNorma35 == '5efccc198072e265448f4e74'){
                this.mostrar=true;
              }
              this.obtenerCentros();
              this.getAllColaboradoresAyuda();
            }
          }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };

    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  NoshowTable:boolean=false;
  getAllColaboradoresAyuda(){

    let dataCol = {
      productoId: this.productoCertificar.idNorma35,
    }
    this.expedienteService.getAyudaColaboradores(dataCol)
    .subscribe( (data:backInter.allColaboradoresAyuda) => {
      if(data.resultado.length>0){
        this.NoshowTable=false;
        this.listaArchivosEmpresa=data.resultado;
        this.colaboradoresList=data.resultado;
        this.listaArchivosEmpresa=data.resultado;
        for(let i=0; i<this.listaArchivosEmpresa.length;i++ ){
          if(this.listaArchivosEmpresa[i].NeedHelp == 1){
            this.listaArchivosEmpresaTmp.push(this.listaArchivosEmpresa[i]);
          }
        }
        this.listaArchivosEmpresa=this.listaArchivosEmpresaTmp;
        this.listaArchivosEmpresaTmp=[];
        this.emitEventToChild();
      }else{
        console.log("aún no tienes resultados");
        this.NoshowTable=true;
      }
    },error=>{
      console.log("Ocurrio un error al encontrar colaboradores");
      console.log(error);
    });

  }

  setNombreCarpeta(folder:string){
    this.carpetaActual = folder;
    this.statusTable=false;
  }

  getArchivos(productoId,folder){
    let datos: any = {
      productoId:productoId, colaboradorId:folder
    };
    this.expedienteService.getTableBolacoradores(productoId,folder)
    .subscribe( (data:any) => {
    });
  }

  getListaArchivos(tipoCarga:number,folder:string, actualizacion?:boolean ){
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              this.productoCertificar_CT = producto;
              // OBTENER ARCHIVOS
              this.puedeCargar = true;
              if(!actualizacion)
                if(tipoCarga == 1){
                  let datos: any = {
                    productoId:this.productoCertificar.idNorma35, colaboradorId:folder
                  };
                  this.expedienteService.getTableBolacoradores(this.productoCertificar.idNorma35,folder)
                  .subscribe( (data:any) => {

                  });
              }
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }
  ////LEER XLSM

  onFileChange(evt: any) {
    this.guardandoArchivo = true;
		/* wire up file reader */
		const target: DataTransfer = <DataTransfer>(evt.target);
		if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    let archivo = evt.target.files[0];
    let fd = new FormData();
    this.info=this.colaboradoresService.getinfo();
    if(this.info.level==6){
      fd.append('file',archivo, archivo.name);
      fd.append('productoId',this.info.productoId);
      fd.append('colaboradorId',this.carpetaActual);
      fd.append('token','$2y$05$VN3dMRXYzo5UfwAt6MAekO8cuJ3uHcbWqZXyUWIv3g.oTdyaDnGCO');
      new Response(fd).text().then(console.log);
      this.expedienteService.saveTableBolacoradores2(fd,this.info.empresaPadre).subscribe( (data:any) => {
        this.guardandoArchivo = false;
        if(data.status){
          this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAOK',1);
          this.getListaArchivos(1,this.carpetaActual,true);
          this.statusArchivos=true;
          this.eventsSubjectStatusArchivos.next(this.carpetaActual);
        }
        else{
          if(data.message == 'File already exist'){
            this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAREP',3);
          }
        }
      }, error  => {
        console.log("error al recuperar certificar vigente");
      });
    }else{ // Inicio usuarios de no centro de trabajo
      fd.append('file',archivo, archivo.name);
      fd.append('productoId',this.productoCertificar.idNorma35);
      fd.append('colaboradorId',this.carpetaActual);
      fd.append('token','$2y$05$VN3dMRXYzo5UfwAt6MAekO8cuJ3uHcbWqZXyUWIv3g.oTdyaDnGCO');
      new Response(fd).text().then(console.log);
      this.expedienteService.saveTableBolacoradores(fd).subscribe( (data:any) => {
        this.guardandoArchivo = false;
        if(data.status){
          this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAOK',1);
          this.getArchivos(this.productoCertificar.idNorma35,this.carpetaActual);
          this.getListaArchivos(1,this.carpetaActual,true);
          this.statusArchivos=false;
          this.statusArchivos=true;
          this.eventsSubjectStatusArchivos.next(this.carpetaActual);
        }
        else{
          if(data.message == 'File already exist'){
            this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAREP',3);
          }
        }
      }, error  => {
        console.log("error al recuperar certificar vigente");
      });
    }
	}

  mensajeSwal(mensaje:string, tipoMsg:number){
    let texto = '';
    this.translateSrv.get(mensaje).subscribe((res: string) => { texto = res; });
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: texto,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }
  obtenerCentros(){
    this.expedienteService.getInfoCentros(this.productoCertificar.fechaNorma35).subscribe( (resu:backInter.getInfoCentros) => {
      this.centrosTrabajoArray=resu.centros;
      this.centrosTrabajo = resu;
      this.centrosTrabajoUsers=this.centrosTrabajoArray.user;
      this.info=this.colaboradoresService.getinfo();

      if(this.info.level==6){
        this.estadoCT=false;
        this.filtroCT(localStorage.getItem('Idct_BD'));
      }else{
        if(this.centrosTrabajo.centros.length ==0){
          this.estadoCT=true;
        }
      }

    });
  }

  colaboradoresList:any;
  emitEventToChild() {
    console.log("Ino a mandar");
    console.log(this.listaArchivosEmpresa);
    this.eventsSubject.next(this.listaArchivosEmpresa);
    this.eventsSubjectStatus.next(this.statusTable);

  }
  statusFiltro:boolean = true;
  listaArchivosEmpresaTmp: any [] = [];
  idct_level1:any;
  filtroCT(IdCt,idcolaborador_ayuda?){
    let rspSi = 'WIZARD.CARGANDO_FILTROS';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    if(this.info.level!=6){
      Swal.fire({
        title: rspSi,
        showConfirmButton: false,
      });
      Swal.showLoading();

    }

    let dataCol = {
      productoId: this.productoCertificar.idNorma35,
    }
    this.expedienteService.getAyudaColaboradores(dataCol)
    .subscribe( (data:backInter.allColaboradoresAyuda) => {
      if(data.resultado.length>0){
        this.NoshowTable=false;
        this.listaArchivosEmpresa=data.resultado;
        for(let i=0; i<this.listaArchivosEmpresa.length;i++ ){
          if(this.listaArchivosEmpresa[i].Institute == IdCt && this.listaArchivosEmpresa[i].NeedHelp == 1){
            this.listaArchivosEmpresaTmp.push(this.listaArchivosEmpresa[i]);
          }
        }
        this.listaArchivosEmpresa=this.listaArchivosEmpresaTmp;
        this.listaArchivosEmpresaTmp=[];
        Swal.close();
        this.emitEventToChild();

      }else{
        //console.log("aún no tienes resultados");
        this.NoshowTable=true;
      }
    });

  }
  statustype:boolean=true;
  changeTable(){
    if(this.statustype){
      this.statustype=false;
      this.eventsSubjectStatusMedicos.next(true);

    }else{
      this.statustype=true;
      this.eventsSubjectStatusMedicos.next(false);
    }

  }


  openDialog(): void {
    let dataModal: any;
    this.eventsSubjectStatusMedicos.next(false);
    const dialogRef = this.dialog.open(MedicoDialog, {
      width: '3500px', height: '600px',
      data: { }

    });
    dialogRef.afterClosed().subscribe(result => {
      this.eventsSubjectStatusMedicos.next(true);
    });

  }
  emitEventToChild2() {
    this.eventsSubject.next(this.statusMedico);
  }

}

@Component({
  selector: 'MedicoDialog',
  templateUrl: 'medicos.dialog.html',
  styleUrls: ['./expediente.component.scss']
})


export class MedicoDialog {
  form: FormGroup;
  private _unsubscribeAll: Subject<any>;
  mensajesTraducirKeys: string[] = [
    'WIZARD.ERROR1',
    'WIZARD.ACC1',
  ];
  mensajesTraducirTS = {
    erro1: '',
    acc1: '',

  };
  productoCertificar: backInter.prodNorma35;
  productoCertificar_CT: backInter.prodNorma35;
  centrosTrabajoArray:any;
  centrosTrabajo: backInter.getInfoCentros;
  centrosTrabajoUsers:any;


  constructor(
    private colaboradoresService: ColaboradoresEncuestadorService,
    private _formBuilder: FormBuilder,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private expedienteService: ExpedienteService,
    public dialogRef: MatDialogRef<MedicoDialog>
  ){

  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
    this.obtieneCertificarActual();
    this.form = this._formBuilder.group({
      workcenter: ['',
      Validators.required
     ],
      doctorName: ['',
        Validators.compose([
          Validators.minLength(10),
          Validators.required
          ])
      ],
      cedula: ['',
        Validators.compose([
          Validators.minLength(7),
          Validators.required
          ])
      ],
      curp: ['',
        Validators.compose([
          Validators.minLength(18),
          Validators.required
          ])
      ],
      especialidad: ['',
        Validators.compose([
          Validators.minLength(6),
          Validators.required
          ])
      ],
      correo: ['',
        Validators.compose([
          Validators.minLength(8),
          Validators.required
          ])
      ],
      telefono: ['',
        Validators.compose([
          Validators.minLength(10),
          Validators.required
          ])
      ],
      /*domicilio: ['',
        Validators.compose([
          Validators.minLength(10),
          Validators.required
          ])
      ],*/

    });
  }
  idiomaActual:string;
  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }
    this.idiomaActual = this.translateSrv.currentLang;
  }


  obtieneCertificarActual(){
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              this.productoCertificar_CT = producto;
              this.obtenerCentros();
            }
          }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };

    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  obtenerCentros(){
    this.expedienteService.getInfoCentros(this.productoCertificar.fechaNorma35).subscribe( (resu:backInter.getInfoCentros) => {
      this.centrosTrabajoArray=resu.centros;
      this.centrosTrabajo = resu;

    });
  }
  info:any;
  idCt:any;
  idnumCT:any;
  nombreCT:any;
  valSelect(idCT,idCTnum,nombre){
    this.idCt=idCT;
    this.idnumCT=idCTnum;
    this.nombreCT=nombre;
  }
  saveData(){
    this.info=this.colaboradoresService.getinfo();
    if(this.form.valid){
      let data={
        "nombre" :$("#doctorName").val(),
        "descripcion" : "El más cabrón de PSeInt hermano",
        "especialidad" : $("#especialidad").val(),
        "cedula" : $("#cedula").val(),
        "centroId" : this.idCt,
        "nombreCT":this.nombreCT,
        "correo":$("#correo").val(),
        //"domicilio":$("#domicilio").val(),
        "telefono":$("#cedula").val(),
        "id_CT" : this.idnumCT,
        "empresaId" : this.info.empresaId,
        "productoId": this.productoCertificar.idNorma35
      };

      this.expedienteService.guardarDoctores(data).subscribe( (resu:colabInter.doctoresRes) => {
        console.log("Save doctor");
        let dataClave={
          "empresaId" : this.info.empresaId,
	        "doctorId" : resu._id,
	        "productoId": this.productoCertificar.idNorma35,
	        "claveProducto" : 1
        }
        this.expedienteService.saveClave(dataClave).subscribe ( (resuClave) => {
          console.log("Clave ");
          console.log(resuClave);
        });
        this.traduceTextosTS();
          Swal.fire(
          ''+this.mensajesTraducirTS.acc1,
          '',
          'success'
        );
        this.dialogRef.close();

      });
    }else{
      this.traduceTextosTS();
      Swal.fire(
        ''+this.mensajesTraducirTS.erro1,
        '',
        'error'
      );

    }
  }
}
